import React, { useEffect } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import axios from 'axios';
import { useState } from 'react';
import CheckoutForm from './CheckoutForm';
import backendUrl from '../configback';

const stripePromise = loadStripe('pk_test_51Nk8Y4F0B89ncn3xWB6ZN3GsbVIVL7Jqfa3jxtIOpPkKHcleHZw4EMPJKd4cRwm34ZARBeYmAWwu3VxyYL1gb6OT00UKNSvfvb');

const Stripe = ({ price, orderId }) => {
    const [clientSecret, setClientSecret] = useState('');
    
    useEffect(() => {
        const createPayment = async () => {
            try {
                const { data } = await axios.post(`${backendUrl}/api/order/create-payment`, { price }, { withCredentials: true });
                setClientSecret(data.clientSecret);
            } catch (error) {
                console.log(error.response.data);
            }
        };

        createPayment();
    }, [price]); // Ensure this effect runs whenever the price changes

    const options = {
        appearance: {
            theme: 'stripe'
        },
        clientSecret
    };

    return (
        <div className='mt-4 md:pb-[25%]'>
            {clientSecret && (
                <Elements options={options} stripe={stripePromise}>
                    <CheckoutForm orderId={orderId} />
                </Elements>
            )}
        </div>
    );
};

export default Stripe;
